import { GET_DEPENDENTS_REPORT } from './dependents-report.types';

export const getDependentsReport = isLeagueAdmin => ({
  type: GET_DEPENDENTS_REPORT.BASE,
  isLeagueAdmin,
});
